import {Component, Input, OnChanges, ChangeDetectionStrategy} from '@angular/core';

import {StatRowInterface} from "../../types/StatsCountByLang";

@Component({
  selector: 'app-resume-statistics-speaker',
  templateUrl: './resume-statistics-speaker.component.html',
  styleUrls: ['./resume-statistics-speaker.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class ResumeStatisticsSpeakerComponent implements OnChanges {
  @Input() statsForASpeaker : any
  @Input() loading : boolean = true;
  @Input() releve : any

  vocalRows: StatRowInterface[] = [];
  translationRows: StatRowInterface[] = [];

  ngOnChanges() {
    this.vocalRows = this.buildRows('VOCAL');
    this.translationRows = this.buildRows('TRADUCTION');
  }

  getQuantityLabel(row: StatRowInterface): string {
    const label = `${row.total} ${this.getLibelleModFact(row.libelleModeFacturation, row.total)}`;
    if (row.modeFacturation !== 'seance') {
      return label;
    }
    return `${label} (${row.nbTextes} texte${row.nbTextes > 1 ? 's' : ''})`;
  }

  private getLibelleModFact(modFac: string, total: number): string {
    if (!modFac) {
      modFac = 'Unité';
    } else if (modFac === 'Forfait') {
      modFac = 'Texte';
    }
    return `${modFac.toLowerCase()}${total > 1 ? 's' : ''}`;
  }

  private buildRows(modeSeance: string): StatRowInterface[] {
    const rowsByKey = new Map<string, StatRowInterface>();

    this.statsForASpeaker
      .filter((seance: any) => seance.modeSeance === modeSeance)
      .forEach((seance: any) => {
        const { langue, libelleCategorie, libelleModeFacturation, modeFacturation, nbUniteFacturation, nbTextes } = seance;
        // Clé composite : une ligne par couple langue / catégorie / mode de facturation
        const key = `${langue}|${libelleCategorie}|${libelleModeFacturation}`;
        const row = rowsByKey.get(key) ?? {
          langue: langue ?? '',
          categorie: libelleCategorie ?? '',
          libelleModeFacturation: libelleModeFacturation ?? '',
          modeFacturation: (modeFacturation ?? '').trim(),
          total: 0,
          nbTextes: 0
        };
        row.total += Number(nbUniteFacturation);
        row.nbTextes += Number(nbTextes ?? 0);
        rowsByKey.set(key, row);
      });

    // Tri par langue, puis catégorie, puis mode de facturation
    return [...rowsByKey.values()].sort((a, b) =>
      a.langue.localeCompare(b.langue)
      || a.categorie.localeCompare(b.categorie)
      || a.libelleModeFacturation.localeCompare(b.libelleModeFacturation));
  }

  get hasVocal(): boolean {
    return this.vocalRows.length > 0;
  }

  get hasTranslations(): boolean {
    return this.translationRows.length > 0;
  }
}
